import React from 'react';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import {actions, selectors} from '../Redux/index';
import {connect} from 'react-redux';
import GridLayout from '../Components/Grid/GridLayout'; 
import GridContainer from './Dashboard/GridContainer';
import {ValueDateCalendarToggle} from './Application/ValueDateCalendar';
import LastUpdateMessage from '../Components/Widgets/LastUpdateMessage';
import { useWindowSize } from '../Hooks/useWindowSize';


const desktopGrid = (isLoaded) => (
    <GridLayout gridName='desktop'>
        {isLoaded && <GridContainer containerId="left" />}
        {isLoaded && <GridContainer containerId="middle" />}
        {isLoaded && (
            <GridContainer containerId="right">
                <div>
                    <div className="grid-item">
                        <div className="grid-item__content grid-item__content--isStatic">
                            <ValueDateCalendarToggle />
                        </div>
                    </div>
                </div>
            </GridContainer>
        )}
    </GridLayout>
);

const mobileGrid = (isLoaded) => (
    <GridLayout gridName='mobile'>
        {isLoaded && <GridContainer containerId="top-left" />}
        {isLoaded && <GridContainer containerId="top-right" />}
        {isLoaded && (
            <div className="grid-layout__container-middle">
                <div className="grid-item">
                    <div className="grid-item__content grid-item__content--isStatic">
                        <ValueDateCalendarToggle />
                    </div>
                </div>
            </div>
        )}
        {isLoaded && <GridContainer containerId="bottom-left" />}
        {isLoaded && <GridContainer containerId="bottom-right" />}
    </GridLayout>
);

/**
 * The dashboard view. This is the application's homepage.
 */
const Dashboard = (props) => {
    const isLoaded = !!props.gridName && props.gridName.toLowerCase() === props.currentBreakpoint.toLowerCase();

    const renderGrid = (breakpoint) => {
        console.log("Dashboard.js - ", breakpoint);
        switch(breakpoint) {
            case 'desktop':
                return desktopGrid(isLoaded);
            case 'mobile':
                return mobileGrid(isLoaded);
            default:
                return desktopGrid(isLoaded);
        }
    };

    const { width } = useWindowSize();

    useEffect(() => {
        let breakpoint = 'desktop';
        // the value was determined manually, trying to prevent line breaks in the displayed data.
        if (width <= 860) {
            breakpoint = 'mobile';
        }

        if (props.currentBreakpoint && breakpoint !== props.currentBreakpoint) {
            window.location.reload();
        } else if (breakpoint !== props.currentBreakpoint) {
            props.updateCurrentBreakpoint(breakpoint);
        }
    }, [width, props.currentBreakpoint, props.updateCurrentBreakpoint]);

    return (
        <div>
            {
                props.currentBreakpoint ? renderGrid(props.currentBreakpoint) : null
            }
            <LastUpdateMessage date={props.lastUpdate} />
        </div>
    );
};




const mapDispatchToProps = (dispatch) => {
    return {
        updateCurrentBreakpoint: (breakpoint) => {
            dispatch(actions.UI.Breakpoint.updateCurrentBreakpoint(breakpoint));
            dispatch(actions.Data.Dashboard.sagaLoadDataStart());
        }
    }
};

const mapStateToProps = (state) => {
    return {
        gridName: selectors.Data.Dashboard.gridName(state),
        isValueDateVisible: selectors.UI.OptionsMenu.isValueDateVisible(state),
        lastUpdate: selectors.Data.Dashboard.lastUpdate(state),
        currentBreakpoint: selectors.UI.Breakpoint.currentBreakpoint(state)
    };
};

Dashboard.propTypes = {
    /**
     * the name of the grid as returned from the API for deciding which grid layout should get rendered
     */
    gridName: PropTypes.string,
    currentBreakpoint: PropTypes.string,
    updateCurrentBreakpoint: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);